export enum RequestsFilterType {
	ALL = "ALL",
	ALL_BY_MONTH = "ALL_BY_MONTH",
	APPLICATION = "APPLICATION",
	APPLICATION_BY_MONTH = "APPLICATION_BY_MONTH",
	COMPANY = "COMPANY",
	COMPANY_BY_MONTH = "COMPANY_BY_MONTH",
	COMPANY_BY_APPLICATION_BY_MONTH = "COMPANY_BY_APPLICATION_BY_MONTH",
}
